<div class="container">
  <div class="row justify-content-around">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <ng-container
        *ngTemplateOutlet="
          rateBreakDownTeamplate;
          context: { resRate: oldReservationData[0]?.room, reservationData: oldReservationData[0], isModified: false }
        "></ng-container>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <ng-container
        *ngTemplateOutlet="
          rateBreakDownTeamplate;
          context: { resRate: currentResData[0]?.room, reservationData: currentResData[0], isModified: true }
        "></ng-container>
    </div>
  </div>
</div>

<ng-template #rateBreakDownTeamplate let-resRate="resRate" let-reservationData="reservationData" let-isModified="isModified">
  <mat-card *ngIf="resRate?.tbody?.length" class="next-col p-3 m-3">
    <h4 class="d-flex justify-content-start">
      <u
        ><strong>{{
          isModified
            ? rGuestBookMessages?.confirmation?.modifiedReservationLabel || "Modified Reservation"
            : rGuestBookMessages?.confirmation?.currentReservationLabel || "Current Reservation"
        }}</strong></u
      >
    </h4>
    <h3>
      <strong>{{ resRate?.roomName }}</strong>
    </h3>

    <div class="row">
      <div class="col">
        <label> {{ rGuestBookMessages?.myReservation?.reservationArrivalDateLabel || "Arrival Date:" }}</label>
        <div>{{ reservationData.arrival | custDate: config?.PropertyData?.dateFunctionConfig }}</div>
      </div>
      <div class="col">
        <label> {{ rGuestBookMessages?.myReservation?.reservationDepartureDateLabel || "Departure Date:" }}</label>
        <div>{{ reservationData.departure | custDate: config?.PropertyData?.dateFunctionConfig }}</div>
      </div>
      <div class="col">
        <label> {{ rGuestBookMessages?.myReservation?.reservationPrimaryGuestLabel || "Primary Guest:" }} </label>
        <div>{{ reservationData?.guestDetails?.[0]?.fName}} , {{ reservationData?.guestDetails?.[0]?.lName}}</div>
      </div>
      <div class="col">
        <label> {{ rGuestBookMessages?.myReservation?.reservationCancelDueDateLabel || "Cancellation Due Date:" }} </label>
        <div>{{ resRate.cancelDueDate }}</div>
      </div>
    </div>

    <h5 id="breakdownlabel" class="my-4">
      <strong>{{ rGuestBookMessages?.myReservation?.reservationRateBreakdownLabel || "RATE BREAKDOWN" }}</strong>
    </h5>
    <div class="table-responsive">
      <table aria-hidden="true" id="ratesTable" class="rate_table table table-hover">
        <thead class="rate_table_head">
          <tr>
            <th id="resRate1" *ngFor="let eachHead of resRate.thead | slice: 0:1">
              {{ rGuestBookMessages.rooms[eachHead] || eachHead }}
            </th>
            <th id="resRate2" style="text-align: right" id="resRate" *ngFor="let eachHead of resRate.thead | slice: 1">
              <span *ngIf="rGuestBookMessages.rooms[eachHead] != 'Date'">
                <i
                  aria-hidden="true"
                  *ngIf="rGuestBookMessages.rooms[eachHead] == 'Other Fee' && resRate.recurringChargesTotal > 0"
                  style="color: #d67373; margin-right: 5px"
                  >*</i
                >
                <i
                  aria-hidden="true"
                  *ngIf="rGuestBookMessages.rooms[eachHead] == 'Resort Fee' && resRate.resortFeeTotal > 0"
                  style="color: #03a9f4; margin-right: 5px"
                  >*</i
                >
                {{ rGuestBookMessages.rooms[eachHead] || eachHead }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rates of resRate.tbody">
            <td *ngIf="!rates.dateRange">{{ rates.date | custDate: config?.PropertyData?.dateFunctionConfig }}</td>
            <td *ngIf="rates.dateRange">
              <span class="nowrap">
                {{ data.fromdate | custDate: config?.PropertyData?.dateFunctionConfig }}
              </span>
              to
              <span class="nowrap">
                {{ data.toDate | custDate: config?.PropertyData?.dateFunctionConfig }}
              </span>
            </td>
            <td style="text-align: right" *ngIf="rates.realvalue">
              {{
                (rates.roomRate || 0) * newRate
                  | custCurrency
                    : this.currencyCode || config?.PropertyData?.currencyCode
                    : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
              }}
            </td>
            <td style="text-align: right" *ngIf="!rates.realvalue">
              {{ rates.roomRate }}
            </td>
            <td style="text-align: right">
              {{
                (rates.resortCharges || 0) * newRate
                  | custCurrency
                    : this.currencyCode || config?.PropertyData?.currencyCode
                    : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
              }}
            </td>
            <td style="text-align: right" *ngIf="resRate?.hasOtherFee">
              {{
                (rates.otherCharges || 0) * newRate
                  | custCurrency
                    : this.currencyCode || config?.PropertyData?.currencyCode
                    : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
              }}
            </td>
          </tr>
          <tr style="background-color: #607d8b; color: white" class="room-rate-total">
            <td>{{ rGuestBookMessages?.book?.bookModalTableFooterTotalText }}</td>
            <ng-container *ngIf="!resRate?.isPackage || resRate.ratecomp">
              <td *ngIf="resRate.roomTotal > 0 && !resRate.notOnlyrate" style="text-align: right">
                {{
                  (resRate.roomTotal || 0) * newRate
                    | custCurrency
                      : this.currencyCode || config.PropertyData.currencyCode
                      : this.countryCode || config.PropertyData.countryCode || "-"
                }}
              </td>
              <td *ngIf="resRate.roomTotal == 0 && !resRate.notOnlyrate" style="text-align: right">
                {{ rGuestBookMessages?.book?.bookModalTableFooterCompText }}
              </td>
              <td style="text-align: right" *ngIf="resRate.onlycomp">
                <span *ngIf="resRate.onlycomp">{{ rGuestBookMessages?.book?.bookModalTableFooterCompText }}</span>
              </td>
            </ng-container>
            <ng-container *ngIf="resRate?.isPackage">
              <td style="text-align: right">{{ rGuestBookMessages?.myReservation?.packageText || "PACKAGE" }}</td>
            </ng-container>

            <td style="text-align: right">
              {{
                (resRate.resortFeeTotal || 0) * newRate
                  | custCurrency
                    : this.currencyCode || config?.PropertyData?.currencyCode
                    : this.countryCode || config?.PropertyData?.countryCode || "-"
              }}
            </td>

            <td style="text-align: right" *ngIf="resRate?.hasOtherFee">
              {{
                (resRate.recurringChargesTotal || 0) * newRate
                  | custCurrency
                    : this.currencyCode || config?.PropertyData?.currencyCode
                    : this.countryCode || config?.PropertyData?.countryCode || "-"
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="resRate?.isPackage && data?.offers?.[0].offerDescriptionExpArray.length > 0">
      <div style="margin: 15px">
        <div id="packagesLabel">
          <span style="font-weight: 900; font-size: 16px">{{
            rGuestBookMessages?.myReservation?.reservationPackageIncludesLabel || "Package includes:"
          }}</span>
        </div>
        <div style="padding: 20px">
          <div *ngFor="let description of data?.offers?.[0].offerDescriptionExpArray">
            <p *ngIf="description?.length">
              <i class="fa fa-dot-circle-o" aria-hidden="true"></i> &nbsp;
              {{ description }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <hr id="totalstartline" />
    <h5 *ngIf="resRate?.recurringChargeDetailOptional?.length > 0" id="enchancementlable">
      <strong>{{ rGuestBookMessages?.myReservation?.reservationStayEnhancementsLabel || "STAY ENHANCEMENTS" }}</strong>
    </h5>
    <ul *ngIf="resRate?.recurringChargeDetailOptional?.length > 0" class="enhanceSelected-conf">
      <ng-container *ngFor="let enhance of resRate.recurringChargeDetailOptional; let enhanceIndex = index">
        <li>
          <div class="row">
            <h5 id="enhancements{{ enhanceIndex }}" class="total_amount enhanceCode-conf col-6 col-sm-6 col-md-6 col-lg-6">
              {{ enhance.description | pcapitalize: rGuestBookPermissions.functionalPermissions.disableCapitalizePipe }}
              <sup>
                <i
                  (click)="showTaxBreakdown(enhance)"
                  data-toggle="modal"
                  href="#modal-breakdown"
                  style="color: #2196f3; cursor: pointer"
                  class="fa fa-info-circle"
                  aria-hidden="true"></i>
                <i aria-hidden="true" [style.color]="enhance.resortCharges ? '#03a9f4' : '#d67373'">*</i>
              </sup>
            </h5>
            <h5
              *ngIf="enhance.bookRecurringChargeWithoutTaxTotal != 0"
              class="total_amount enhanceCharge col-5 col-sm-5 col-md-5 col-lg-5"
              id="enhancementsvalue{{ enhanceIndex }}">
              {{
                (enhance.bookRecurringChargeWithoutTaxTotal || 0) * newRate
                  | custCurrency
                    : this.currencyCode || config?.PropertyData?.currencyCode
                    : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
              }}
            </h5>
            <h5
              *ngIf="enhance.bookRecurringChargeWithoutTaxTotal == 0"
              class="total_amount enhanceCharge col-5 col-sm-5 col-md-5 col-lg-5"
              id="enhancementsvalue{{ enhanceIndex }}">
              {{ rGuestBookMessages?.myReservation?.reservationStayEnhancementsCompText || "Complimentary" }}
            </h5>
          </div>
        </li>
      </ng-container>
    </ul>

    <hr *ngIf="resRate?.recurringChargeDetailOptional?.length > 0" />
    <div class="row">
      <h5 class="total_amount col-6 col-sm-6 col-md-6 col-lg-6" id="packTotalLabel">
        <strong *ngIf="!resRate.bothavailable"
          ><span *ngIf="!resRate?.isPackage">{{ rGuestBookMessages?.myReservation?.reservationRoomTotalLabel || "Room Total" }}</span
          ><span *ngIf="resRate?.isPackage">{{ rGuestBookMessages?.myReservation?.reservationPackageTotalLabel || "Package Total" }}</span
          >:
        </strong>
        <strong *ngIf="resRate.bothavailable"
          ><span>{{ rGuestBookMessages?.myReservation?.reservationroomRateAndPackageTotal || "Package and Room Total" }}</span>
        </strong>
      </h5>
      <h5 class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-5 pr-0" id="packTotalLabelvalue">
        <ng-container *ngIf="!resRate.bothavailable">
          <span *ngIf="resRate?.isPackage; else roomRateTotal">
            {{
              (resRate.quoteTotal || 0) * newRate
                | custCurrency
                  : this.currencyCode || config?.PropertyData?.currencyCode
                  : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
            }}
          </span>
          <ng-template #roomRateTotal>
            {{
              (resRate.roomTotal || 0) * newRate
                | custCurrency
                  : this.currencyCode || config?.PropertyData?.currencyCode
                  : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
            }}
          </ng-template>
        </ng-container>
        <ng-container *ngIf="resRate.bothavailable">
          <span>
            {{
              (resRate.bookPackageRateTotal || 0) * newRate
                | custCurrency
                  : this.currencyCode || config?.PropertyData?.currencyCode
                  : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
            }}
          </span>
        </ng-container>
      </h5>
      <ng-container *ngIf="rGuestBookPermissions.functionalPermissions && !rGuestBookPermissions.functionalPermissions.hideTax">
        <h5 class="total_amount col-6 col-sm-6 col-md-6 col-lg-6" id="taxlabelroom">
          <ng-container *ngIf="!resRate.bothavailable">
            <strong
              ><span *ngIf="!resRate?.isPackage">{{
                rGuestBookMessages?.myReservation?.reservationRoomTotalTaxLabel || "Room Total Tax"
              }}</span
              ><span *ngIf="resRate?.isPackage">{{
                rGuestBookMessages?.myReservation?.reservationPackageTotalTaxLabel || "Package Total Tax"
              }}</span
              >:
            </strong>
          </ng-container>
          <ng-container *ngIf="resRate.bothavailable">
            <strong
              ><span>
                {{ rGuestBookMessages?.myReservation?.reservationroomRateAndPackageTaxTotal || "Package and Room Tax Total" }}
              </span>
            </strong>
          </ng-container>
        </h5>
        <h5 class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-5 pr-0" id="taxlabelroomvalue">
          <ng-container *ngIf="!resRate.bothavailable">
            <span *ngIf="resRate?.isPackage; else roomTaxTotal">
              {{
                (resRate.quoteTotalTax || 0) * newRate
                  | custCurrency
                    : this.currencyCode || config?.PropertyData?.currencyCode
                    : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
              }}
            </span>
            <ng-template #roomTaxTotal>
              {{
                (resRate.roomTaxTotal || 0) * newRate
                  | custCurrency
                    : this.currencyCode || config?.PropertyData?.currencyCode
                    : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
              }}
            </ng-template>
          </ng-container>
          <ng-container *ngIf="resRate.bothavailable">
            <span>
              {{
                (resRate.bookPackageTaxTotal || 0) * newRate
                  | custCurrency
                    : this.currencyCode || config?.PropertyData?.currencyCode
                    : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
              }}
            </span>
          </ng-container>
        </h5>
      </ng-container>
      <ng-container *ngIf="!resRate.bothavailable">
        <h5
          *ngIf="resRate.recurringChargesTotal > 0 && !resRate?.isPackage"
          class="total_amount col-6 col-sm-6 col-md-6 col-lg-6"
          id="reservationOtherFeeTotalLabel">
          <strong>{{ rGuestBookMessages?.myReservation?.reservationOtherFeeTotalLabel || "Other Fee Total:" }} </strong>
          <sup>
            <i *ngIf="resRate.recurringChargesTotal > 0" aria-hidden="true" style="color: #d67373">*</i>
          </sup>
        </h5>
        <h5
          *ngIf="resRate.recurringChargesTotal > 0 && !resRate?.isPackage"
          class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-5 pr-0"
          id="reservationOtherFeeTotalLabelvalue">
          {{
            (resRate.recurringChargesTotal || 0) * newRate
              | custCurrency
                : this.currencyCode || config?.PropertyData?.currencyCode
                : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
          }}
        </h5>
        <ng-container *ngIf="rGuestBookPermissions.functionalPermissions && !rGuestBookPermissions.functionalPermissions.hideTax">
          <h5
            *ngIf="resRate.recurringChargesTotalTax > 0 && !resRate?.isPackage"
            class="total_amount col-6 col-sm-6 col-md-6 col-lg-6"
            id="reservationOtherFeeTotalTaxLabel">
            <strong>{{ rGuestBookMessages?.myReservation?.reservationOtherFeeTotalTaxLabel || "Other Fee Tax Total: " }}</strong>
          </h5>
          <h5
            *ngIf="resRate.recurringChargesTotalTax > 0 && !resRate?.isPackage"
            class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-5 pr-0"
            id="reservationOtherFeeTotalTaxLabelvalue">
            {{
              (resRate.recurringChargesTotalTax || 0) * newRate
                | custCurrency
                  : this.currencyCode || config?.PropertyData?.currencyCode
                  : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
            }}
          </h5>
        </ng-container>
        <h5
          *ngIf="resRate.resortFeeTotal > 0 && !resRate?.isPackage"
          class="total_amount col-6 col-sm-6 col-md-6 col-lg-6"
          id="reservationResortFeeTotalLabel">
          <strong>{{ rGuestBookMessages?.myReservation?.reservationResortFeeTotalLabel || "Resort Fee Total: " }}</strong>
          <sup>
            <i *ngIf="resRate.resortFeeTotal > 0" aria-hidden="true" style="color: #03a9f4">*</i>
          </sup>
        </h5>
        <h5
          *ngIf="resRate.resortFeeTotal > 0 && !resRate?.isPackage"
          class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-5 pr-0"
          id="reservationResortFeeTotalLabelvalue">
          {{
            (resRate.resortFeeTotal || 0) * newRate
              | custCurrency
                : this.currencyCode || config?.PropertyData?.currencyCode
                : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
          }}
        </h5>
        <ng-container *ngIf="rGuestBookPermissions.functionalPermissions && !rGuestBookPermissions.functionalPermissions.hideTax">
          <h5
            *ngIf="(resRate.resortFeeEnhancementTotalTax > 0 || resRate.resortFeeMandatoryTotalTax > 0) && !resRate?.isPackage"
            class="total_amount col-6 col-sm-6 col-md-6 col-lg-6"
            id="reservationResortFeeTotalTaxLabel">
            <strong>{{ rGuestBookMessages?.myReservation?.reservationResortFeeTotalTaxLabel || "Resort Fee Tax Total: " }}</strong>
          </h5>
          <h5
            *ngIf="(resRate.resortFeeEnhancementTotalTax > 0 || resRate.resortFeeMandatoryTotalTax > 0) && !resRate?.isPackage"
            class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-5 pr-0"
            id="reservationResortFeeTotalTaxLabelvalue">
            {{
              (resRate.resortFeeEnhancementTotalTax + resRate.resortFeeMandatoryTotalTax || 0) * newRate
                | custCurrency
                  : this.currencyCode || config?.PropertyData?.currencyCode
                  : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
            }}
          </h5>
        </ng-container>
        <h5
          *ngIf="resRate?.isPackage && resRate.enhancementsTotal > 0"
          class="total_amount col-6 col-sm-6 col-md-6 col-lg-6"
          id="reservationEnhancementsTotalLabel">
          <strong>{{ rGuestBookMessages?.myReservation?.reservationEnhancementsTotalLabel || "Enhancements Total: " }}</strong>
        </h5>
        <h5
          *ngIf="resRate?.isPackage && resRate.enhancementsTotal > 0"
          class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-5 pr-0"
          id="reservationEnhancementsTotalLabelvalue">
          {{
            (resRate.enhancementsTotal || 0) * newRate
              | custCurrency
                : this.currencyCode || config?.PropertyData?.currencyCode
                : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
          }}
        </h5>

        <h5
          *ngIf="resRate?.isPackage && resRate.enhancementsTotalTax > 0"
          class="total_amount col-6 col-sm-6 col-md-6 col-lg-6"
          id="reservationEnhancementsTotalTaxLabel">
          <strong>{{ rGuestBookMessages?.myReservation?.reservationEnhancementsTotalTaxLabel || "Enhancements Total Tax:" }}</strong>
        </h5>
        <h5
          *ngIf="resRate?.isPackage && resRate.enhancementsTotalTax > 0"
          class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-5 pr-0"
          id="reservationEnhancementsTotalTaxLabelvalue">
          {{
            (resRate.enhancementsTotalTax || 0) * newRate
              | custCurrency
                : this.currencyCode || config?.PropertyData?.currencyCode
                : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
          }}
        </h5>
      </ng-container>
    </div>
    <hr id="totalendline" />
    <div class="row">
      <h5 class="col-6 col-sm-6 col-md-6 col-lg-6 grand_total grand_title">
        <strong id="grand_total_text">{{ rGuestBookMessages?.myReservation?.reservationTotalText || " Total:" }}</strong>
        <p id="includetax_tx">
          {{ rGuestBookMessages?.myReservation?.reservationInclusionTaxText || "(*Inclusive of taxes)" }}
        </p>
      </h5>
      <h5 class="col-5 col-sm-5 col-md-5 col-lg-5 grand_total grand_total_value pr-0" id="grand_total_value">
        <span *ngIf="resRate?.isPackage; else roomGrandTotal">
          {{
            (resRate.quoteGrandTotal || 0) * newRate
              | custCurrency
                : this.currencyCode || config?.PropertyData?.currencyCode
                : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
          }}
        </span>
        <ng-template #roomGrandTotal>
          {{
            (resRate.quoteGrandTotal || 0) * newRate
              | custCurrency
                : this.currencyCode || config?.PropertyData?.currencyCode
                : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
          }}
        </ng-template>
      </h5>
    </div>

    <div class="mb-0 row m-50">
      <h5 class="col-6 col-sm-6 col-md-6 col-lg-6 grand_total grand_title" id="reservationDepositAmountText">
        <strong>{{ rGuestBookMessages?.myReservation?.reservationDepositAmountText || " Deposit Amount:" }}</strong>
      </h5>
      <h5 class="col-5 col-sm-5 col-md-5 col-lg-5 grand_total grand_total_value pr-0" id="reservationDepositAmountTextvalue">
        {{
          (resRate.depositAmountDue || 0) * newRate
            | custCurrency
              : this.currencyCode || config?.PropertyData?.currencyCode
              : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
        }}
      </h5>
    </div>
    <!-- START - Deposit Received Amount show for old Res -->
    <div class="mb-0 row m-50" [class.height-26]="isModified" *ngIf="data?.stayInfo?.DepositReceived">
      <ng-container *ngIf="!isModified">
        <h5 class="col-6 col-sm-6 col-md-6 col-lg-6 grand_total grand_title" id="reservationDepositAmountText">
          <strong>{{ rGuestBookMessages?.myReservation?.reservationDepositReceivedAmountText || " Deposit Amount Received:" }}</strong>
        </h5>
        <h5 class="col-5 col-sm-5 col-md-5 col-lg-5 grand_total grand_total_value pr-0" id="reservationDepositAmountTextvalue">
          {{
            (data?.stayInfo?.DepositReceived || 0) * newRate
              | custCurrency
                : this.currencyCode || config?.PropertyData?.currencyCode
                : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
          }}
        </h5>
      </ng-container>
    </div>
    <!-- END - Deposit Received Amount show for old Res -->
    <div
      class="row m-50 m-t-0"
      *ngIf="
        resRate.cancelAmountDue && resRate.cancelAmountDue != 'NA' && resRate.cancelAmountDue != '0.00' && resRate.cancelAmountDue != '0'
      ">
      <h5 class="col-6 col-sm-6 col-md-6 col-lg-6 grand_total grand_title">
        <strong id="cancelfeelabel">{{
          rGuestBookMessages?.myReservation?.reservationCancellationAmountText || " Cancellation Amount:"
        }}</strong>
        <span id="canclatiolduetext" style="font-size: 8px; display: block">{{
          rGuestBookMessages?.myReservation?.reservationCancellationDueDateText || "Charged when canceled on/after due date"
        }}</span>
      </h5>
      <h5 class="col-5 col-sm-5 col-md-5 col-lg-5 grand_total grand_total_value pr-0" id="cancelfeelabelvalue">
        {{
          (resRate.cancelAmountDue || 0) * newRate
            | custCurrency
              : this.currencyCode || config?.PropertyData?.currencyCode
              : this.countryCode || config?.PropertyData?.countryCode || rGuestBookMessages?.confirmation?.confirmationTableCompText
        }}
      </h5>
    </div>

    <div class="container" *ngIf="reservationData?.cardDetails">
      <div class="row">
        <h5 class="grand_total mb-0">
          <strong>{{ rGuestBookMessages?.confirmation?.cardDetailText || "Payment Method Details :" }} </strong>
        </h5>
      </div>

      <div class="row align-items-center" *ngIf="!reservationData?.cardDetails?.isNewCard">
        <ng-container *ngIf="reservationData?.cardDetails?.cardLast4">
          <img alt="Card" class="cardIssuerLogo mx-2" src="assets/images/card/{{ reservationData?.cardDetails?.cardIcon }}.svg" />
          <span class="mx-2"
            ><strong>{{ reservationData?.cardDetails?.cardTypeDesc | uppercase }} </strong></span
          >
          {{ rGuestBookMessages?.confirmation?.cardEndingText || "Ending with" }}
          <span class="mx-2"
            ><strong>{{ reservationData?.cardDetails?.cardLast4 }}</strong></span
          >
        </ng-container>
        <ng-container *ngIf="!reservationData?.cardDetails?.cardLast4">
          <img alt="Card" class="cardIssuerLogo mx-2" src="assets/images/card/cashwallet.svg" />
          <span class="mx-2">{{ rGuestBookMessages?.confirmation?.cashText || " Cash" }}</span>
        </ng-container>
      </div>

      <div class="row align-items-center" *ngIf="reservationData?.cardDetails?.isNewCard">
        <img alt="Card" class="cardIssuerLogo mx-2" src="assets/images/card/{{ reservationData?.cardDetails?.cardInfo?.cardIcon }}.svg" />
        <span class="mx-2"
          ><strong>{{ reservationData?.cardDetails?.cardInfo?.cardIssuer | uppercase }}</strong></span
        >
        {{ rGuestBookMessages?.confirmation?.cardEndingText || "Ending with" }}
        <span class="mx-2"
          ><strong>{{ reservationData?.cardDetails?.cardInfo?.accountNumberMasked }}</strong></span
        >
      </div>
    </div>

    <div class="container" *ngIf="!reservationData?.cardDetails">
      <div class="row">
        <h5 class="grand_total mb-0">
          <strong>{{ rGuestBookMessages?.confirmation?.cardDetailText || "Payment Method Details :" }} </strong>
        </h5>
      </div>
      <div class="row align-items-center">
        <img alt="Card" class="cardIssuerLogo mx-2" src="assets/images/card/cashwallet.svg" />
        <span class="mx-2">{{ rGuestBookMessages?.confirmation?.cashText || " Cash" }}</span>
      </div>
    </div>
  </mat-card>
</ng-template>
